var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('GridPage',{attrs:{"form-default":{
            level: '100',
            status: 'pending',
        },"filters-default":{
            level: '',
            status: '',
            sort: 'name',
        },"filter-items":[
            {
                vModel: 'level',
                title: '権限',
                options: [
                    { text: '全て', value: '' },
                    { text: 'なし', value: '000' },
                    { text: '一般', value: '100' },
                    { text: '編集者', value: '200' },
                    { text: '管理者', value: '300' } ],
            },
            {
                vModel: 'status',
                title: '状態',
                options: [
                    { text: '全て', value: '' },
                    { text: '準備', value: 'pending' },
                    { text: '稼働', value: 'activated' },
                    { text: '停止', value: 'suspended' } ],
            },
            {
                vModel: 'sort',
                title: '順番',
                options: [
                    {
                        text: '▲ 名前',
                        value: 'name',
                    },
                    { text: '▼ 名前', value: '-name' } ],
            } ],"filters-q-placeholder":"名前、よみ、メール","form-modal-id":"user","search-action":"user/index"},scopedSlots:_vm._u([{key:"form",fn:function(ref){
        var form = ref.form;
        var init = ref.init;
return [_c('User',{attrs:{"model":form,"init":init}})]}},{key:"column",fn:function(ref){
        var item = ref.item;
return [_c('b-col',{staticClass:"align-self-center",attrs:{"md":"6"}},[_c('p',{staticClass:"mb-1"},[_c('b-badge',{attrs:{"variant":_vm.$store.getters['user/level2variant'](item.level)}},[_vm._v("\n                    "+_vm._s(_vm.trans.labels[
                    'users.level.' + item.level
                    ])+"\n                ")])],1),_vm._v(" "),(item.last_name)?_c('ruby',[_vm._v("\n                    "+_vm._s(item.last_name)+"\n                    "),(item.last_kana)?_c('rt',[_vm._v("\n                    "+_vm._s(item.last_kana)+"\n                    ")]):_vm._e()]):_vm._e(),_vm._v(" "),(item.first_name)?_c('ruby',[_vm._v("\n                    "+_vm._s(item.first_name)+"\n                    "),(item.first_kana)?_c('rt',[_vm._v("\n                    "+_vm._s(item.first_kana)+"\n                    ")]):_vm._e()]):_vm._e()]),_vm._v(" "),_c('b-col',{staticClass:"align-self-center",attrs:{"md":"6"}},[(item.email)?[_c('i',{staticClass:"far fa-fw fa-envelope"}),_vm._v(" "),_c('b-link',{attrs:{"href":'mailto:' + item.email}},[_vm._v(_vm._s(item.email))])]:_vm._e()],2)]}}])},[_vm._v(" "),[_c('b-col',{attrs:{"md":"6"}},[_vm._v(" 名前 ")]),_vm._v(" "),_c('b-col',{attrs:{"md":"6"}},[_vm._v(" メール ")])]],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }